import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Oktoberfest} from "../../game/Oktoberfest";
import {OktoberfestSymbolState} from "../../game/symbol/OktoberfestSymbolConfig";
import {OktoberfestSymbol} from "../../game/symbol/OktoberfestSymbol";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class GameHelper {
    public static isDesktop(): boolean {
        let flag: boolean = false;

        if (NolimitApplication.apiPlugin.options.device === "desktop") {
            flag = true;
        }

        return flag;
    }

    static createRenderedTextureFromContainer(originalContainer: PIXI.Container, resolution: number, paddingX: number = 0, paddingY: number = 0): PIXI.Texture {
        let renderer: PIXI.Renderer = NolimitApplication.pixiApp.renderer;
        let canvasTexture: PIXI.Texture;
        canvasTexture = renderer.generateTexture(originalContainer, PIXI.SCALE_MODES.LINEAR, resolution);
        canvasTexture.baseTexture.resolution = resolution;
        canvasTexture.baseTexture.update();
        return canvasTexture;
    }

    static getVisibleSymbolsFromReelsData(allReels: string[][]): string[][] {
        let visibleSymbols: string[][] = [];
        for (let i: number = 0; i < allReels.length; i++) {
            visibleSymbols.push(allReels[i].slice(2, 5));
        }
        return visibleSymbols;
    }

    public static isReel2Stacked(reels: string[][]): boolean {
        return reels[1][2].indexOf("W1") > -1 && reels[1][3].indexOf("W1") > -1 && reels[1][4].indexOf("W1") > -1;
    }

    public static isReel4Stacked(reels: string[][]): boolean {
        return reels[3][2].indexOf("W2") > -1 && reels[3][3].indexOf("W2") > -1 && reels[3][4].indexOf("W2") > -1;
    }

    public static toPlayAttentioOn1stReel(): boolean {
        const isStackedMode: boolean = Oktoberfest.model.parsedGameData.mode === "STACKED_PARTY_SPIN";
        return (!isStackedMode && (Oktoberfest.model.parsedGameData.overlayWilds[2][0] === "W" || Oktoberfest.model.parsedGameData.overlayWilds[2][1] === "W"))
    }

    public static resetAllSymbols(): void {
        Oktoberfest.model.reels.forEach((eachReel: string[], reelId: number) => {
            eachReel.forEach((symName: string, symIndex: number) => {
                if (symIndex <= 2) {
                    const symbol = Oktoberfest.reels[reelId].getSymbol(symIndex);
                    symbol.getStateAnimation(OktoberfestSymbolState.NORMAL,
                        {duration: 0.01, alpha: 1},
                        {duration: 0.01, alpha: 0}
                    );
                }
            });
        });
    }

    public static dimDownAllSymbols(symbol: OktoberfestSymbol, matchingSym: string): void {
        if (symbol.symbolName.indexOf(matchingSym) == -1) {
            symbol.getStateAnimation(OktoberfestSymbolState.NO_WIN,
                {duration: 0.01, alpha: 1},
                {duration: 0.01, alpha: 0}
            );
        }
    }

    public static dimSymbols(): void {
        Oktoberfest.model.reels.forEach((eachReel: string[], reelId: number) => {
            eachReel.forEach((symName: string, symIndex: number) => {
                if (symIndex <= 2) {
                    const symbol = Oktoberfest.reels[reelId].getSymbol(symIndex);
                    symbol.getStateAnimation(OktoberfestSymbolState.NO_WIN,
                        {duration: 0.01, alpha: 1},
                        {duration: 0.01, alpha: 0}
                    );
                }
            });
        });
    }

    public static isFSMode(): boolean {
        return Oktoberfest.model.parsedGameData.mode.indexOf(GameMode.FREESPIN) > -1;
    }

    public static isNextModeNormal(): boolean {
        return Oktoberfest.model.parsedGameData.nextMode.indexOf(GameMode.NORMAL) > -1;
    }
}
